// extracted by css-extract-rspack-plugin
export default {"wrapper":"zTkF1pkbCsw_xpkZ","slide-in":"lBK5b_XRSm0Zt2_g","closing":"aeEwNxCYQAY344BC","container":"WrTGqfSi8AnxBAYz","link":"Rfzz7QxI0lQe3rK8"};